import React, { useContext } from 'react';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Skeleton, SkeletonItem, Spinner } from '@fluentui/react-components';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@adscore/with-responsive-size';

const getShimmerStyles = () => ({
  businessInfoShimmer: {
    width: '100%',
    maxWidth: '600px',
    padding: '10px 0',
    display: 'flex',
    flexDirection: 'column',
  },
  loadingBusinessInfo: {
    width: '100%',
    display: 'flex',
  },
  countryBizNameContainer: {
    width: '100%',
    maxWidth: '600px',
    padding: '10px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  'countryBizNameContainer-m': {
    flexDirection: 'column',
    alignItems: 'center',
  },
  'countryBizNameContainer-s': {
    flexDirection: 'column',
    alignItems: 'center',
  },
  countrySelectionContainer: {
    height: 32,
    margin: '10px 20px 10px 0px',
  },
  'countrySelectionContainer-m': {
    width: '100%',
    margin: '10px 0',
  },
  'countrySelectionContainer-s': {
    width: '100%',
    margin: '10px 0',
  },
  businessNameContainer: {
    height: 32,
    margin: '10px 0',
  },
  'businessNameContainer-m': {
    width: '100%',
    maxWidth: '100%',
  },
  'businessNameContainer-s': {
    width: '100%',
    maxWidth: '100%',
  },
  shimmerUnit: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  labelShimmer: {
    width: 100,
  },
  subtitleShimmer: {
    width: 150,
    height: 22,
  },
});

export const BusinessInfoShimmer = () => {
  const classes = useDefaultStyles(getShimmerStyles);
  const i18n = useContext(I18nContext);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);

  return (
    <div className={classNames('business-info-shimmer', classes.businessInfoShimmer)}>
      <div className={classes.loadingBusinessInfo}>
        <Spinner
          className={classNames(classes.spinner, 'loading-spinner')}
          size="tiny"
          label={i18n.getString(_TL_('Getting information from your website...'))}
        />
      </div>
      <div className={classNames('shimmer-wrapper', classes.shimmerWrapper)}>
        <div className={classNames('country-biz-name-container', classes.countryBizNameContainer, classes[`countryBizNameContainer-${displayMode}`])}>
          <div className={classNames('shimmer-unit', classes.shimmerUnit)}>
            <div className={classNames('label-shimmer', classes.labelShimmer)}>
              <Skeleton> <SkeletonItem style={{ height: '22px', width: '100px' }} /> </Skeleton>
            </div>
            <div className={classNames('country-shimmer', classes.countrySelectionContainer, classes[`countrySelectionContainer-${displayMode}`])}>
              <Skeleton> <SkeletonItem style={{ height: '32px' }} /> </Skeleton>
            </div>
          </div>
          <div className={classNames('shimmer-unit', classes.shimmerUnit)}>
            <div className={classNames('label-shimmer', classes.labelShimmer)}>
              <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '22px', width: '100px' }} /> </Skeleton>
            </div>
            <div className={classNames('business-name-shimmer', classes.businessNameContainer, classes[`businessNameContainer-${displayMode}`])}>
              <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '22px', width: '100px' }} /> </Skeleton>
            </div>
          </div>
        </div>
        <div className={classNames('subtitle-shimmer', classes.subtitleShimmer)}>
          <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '22px', width: '150px' }} /> </Skeleton>
        </div>
        <div className={classNames('country-biz-name-container', classes.countryBizNameContainer, classes[`countryBizNameContainer-${displayMode}`])}>
          <div className={classNames('shimmer-unit', classes.shimmerUnit)}>
            <div className={classNames('label-shimmer', classes.labelShimmer)}>
              <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '22px', width: '100px' }} /> </Skeleton>
            </div>
            <div className={classNames('country-shimmer', classes.countrySelectionContainer, classes[`countrySelectionContainer-${displayMode}`])}>
              <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '32px' }} /> </Skeleton>
            </div>
          </div>
          <div className={classNames('shimmer-unit', classes.shimmerUnit)}>
            <div className={classNames('label-shimmer', classes.labelShimmer)}>
              <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '22px', width: '100px' }} /> </Skeleton>
            </div>
            <div className={classNames('business-name-shimmer', classes.businessNameContainer, classes[`businessNameContainer-${displayMode}`])}>
              <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '32px' }} /> </Skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
